var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRotate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.68,
  d: "M2.5 10A7.5 7.5 0 0 1 10 2.5a8.13 8.13 0 0 1 5.617 2.283L17.5 6.667m0 0V2.5m0 4.167h-4.167M17.5 10a7.5 7.5 0 0 1-7.5 7.5 8.13 8.13 0 0 1-5.617-2.283L2.5 13.333m0 0h4.167m-4.167 0V17.5"
})));
export default SvgRotate;